<template>
    <div class="OrderDetails">
        <Header></Header>
        <div style="width: 1000px;overflow: hidden;overflow-y: auto;scrollbar-width: none; " :style="{
            'margin-left': innerWidth > 1000 ? (innerWidth - 1000) / 2 + 'px' : '0px',
            'height': (innerHeight - 70 - 68) + 'px'
        }">
        <div class="title">我的订单</div>


            



        </div>
        <Suspension></Suspension>
        <Footer></Footer>

    </div>



</template>


<script>
import Header from "../../components/common/Header"
import Footer from "../../components/common/Footer"
import Suspension from "../../components/common/Suspension"

import {
    // getByUrl,
    //  sendPostRqeByJSON
} from '@/api/api.js';


import {
    getLocalStorage
} from '@/utils/util.js';



export default {
    name: "OrderDetails",
    components: {
        Header,
        Footer,
        Suspension
    },
    data() {
        return {
            innerWidth: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
            innerHeight: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
        }
    },

    mounted() {
        console.log(JSON.parse(getLocalStorage('goodInfo')))

    },
    methods: {
       
    },
}
</script>
<style scoped>
.title {
    font-size: 25px;
    line-height: 40px;
    font-weight: 500;
    margin-top: 50px;
}

</style>